import { createBaseStore, BaseStoreState } from '@tasama/utils';

interface ProposalReviewProgressState extends BaseStoreState {
  srAttemptId: string;
  reviewCompleted: boolean;
  setSrAttemptId: (_srAttemptId: string) => void;
  setReviewCompleted: (_completed: boolean) => void;
  resetProgress: () => void;
}

/**
 * Proposal Review Progress Store
 *
 * Manages the completion state for the Proposal Review flow.
 * Stores the srAttemptId so it persists across navigation.
 */
export const useProposalProgress = createBaseStore<ProposalReviewProgressState>(
  {
    srAttemptId: '',
    reviewCompleted: false,
    setSrAttemptId: () => {},
    setReviewCompleted: () => {},
    resetProgress: () => {},
  },
  (set, _get) => ({
    setSrAttemptId: (srAttemptId: string) => set({ srAttemptId }),
    setReviewCompleted: (completed: boolean) =>
      set({ reviewCompleted: completed }),
    resetProgress: () => set({ srAttemptId: '', reviewCompleted: false }),
  })
);
